import moment from 'moment-timezone';
import {colors} from 'styles/colors';

/**
 * 공사 유형 옵션 목록
 * 공사 유형 선택을 위한 옵션 목록입니다.
 */
export const constructionTypeOptions = [
  {
    text: 'architecture',
    value: 'ARCHITECTURE',
  },
  {
    text: 'civilEngineering',
    value: 'CIVIL_ENGINEERING',
  },
  {
    text: 'plant',
    value: 'PLANT',
  },
  {
    text: 'etc',
    value: 'ETC',
  },
];

/**
 * 타임존 옵션 목록
 * 타임존 선택을 위한 옵션 목록입니다.
 */
export const timeZoneOptions: {text: string; value: string}[] = [];

const timezoneList = moment.tz.names();

for (const timezone of timezoneList) {
  timeZoneOptions.push({text: timezone, value: timezone});
}

/**
 * 고용 상태 옵션 목록
 * 근로자의 고용 상태 선택을 위한 옵션 목록입니다.
 */
export const employmentStatusOptions = [
  {
    text: 'employed',
    value: 'employed',
  },
  {
    text: 'onLeave',
    value: 'onLeave',
  },
  {
    text: 'resigned',
    value: 'resigned',
  },
];

/**
 * 현장 출석 통계 옵션 목록
 * 현장 출석 통계 포함/제외 선택을 위한 옵션 목록입니다.
 */
export const siteAttendanceStatsOptions = [
  {
    text: 'included',
    value: true,
  },
  {
    text: 'excluded',
    value: false,
  },
];

/**
 * 위험 평가 카테고리 검색 옵션 목록
 * 위험 평가 카테고리 검색을 위한 옵션 목록입니다.
 */
export const searchRiskCategoryOption = [
  {text: 'viewEntire', value: 'viewEntire'},
  {text: 'initialRiskAssessment', value: 'firstriskassessmentdocuments'},
  {text: 'regularRiskAssessment', value: 'regularriskassessmentdocuments'},
];

/**
 * 시공사 소유자 권한 옵션 목록
 * 시공사 소유자 권한 선택을 위한 옵션 목록입니다.
 */
export const contractorOwnerPermissionOption = [
  {text: 'contractorCO_OWNER', value: 'CO_OWNER'},
  {text: 'contractorMANAGER', value: 'MANAGER'},
];

/**
 * 협력사 소유자 권한 옵션 목록
 * 협력사 소유자 권한 선택을 위한 옵션 목록입니다.
 */
export const partnerOwnerPermissionOption = [
  {text: 'partnerCO_OWNER', value: 'CO_OWNER'},
  {text: 'partnerMANAGER', value: 'MANAGER'},
];

/**
 * 현장 소유자 권한 옵션 목록
 * 현장 소유자 권한 선택을 위한 옵션 목록입니다.
 */
export const tongOwnerPermissionOption = [
  {text: 'tongCO_OWNER', value: 'CO_OWNER'},
  {text: 'tongMANAGER', value: 'MANAGER'},
];

/**
 * 사용/미사용 옵션 목록
 * 기능 사용 여부 선택을 위한 옵션 목록입니다.
 */
export const usingNotUsingOption = [
  {text: 'used', value: true},
  {text: 'notUsed', value: false},
];

/**
 * 현장 분류 데이터 목록
 * 현장 분류 선택을 위한 옵션 목록입니다.
 */
export const placeClassificationData = [
  {text: '상', value: 'upper'},
  {
    text: '중',
    value: 'middle',
  },
  {text: '하', value: 'lower'},
];

/**
 * 교육 유형 옵션 목록
 * 교육 유형 선택을 위한 옵션 목록입니다.
 */
export const educationTypeOption = [
  {text: 'viewEntire', value: undefined},
  {text: 'newEmployeeTraining', value: 'DEFAULT'},
  {text: 'specialTraining', value: 'SPECIAL_EDUCATION'},
  {text: 'regularTraining', value: 'REGULAR_EDUCATION'},
  {text: 'supervisorTraining', value: 'ADMINISTRATOR_EDUCATION'},
  {text: 'etc', value: 'ETC'},
];

/**
 * 교육 유형 생성 옵션 목록
 * 교육 유형 생성 시 선택할 수 있는 옵션 목록입니다.
 */
export const educationTypeCreateOption = [
  {text: 'noSelect', value: '', color: colors.black},
  {
    text: 'educationTypeStatusBundle',
    value: 'DEFAULT',
    color: colors.primary2,
  },
  {text: 'specialTraining', value: 'SPECIAL_EDUCATION', color: colors.primary},
  {
    text: 'regularTraining',
    value: 'REGULAR_EDUCATION',
    color: colors.darkLimeGreen,
  },
  {
    text: 'supervisorTraining',
    value: 'ADMINISTRATOR_EDUCATION',
    color: colors.black,
  },
  {
    text: 'educationTypeStatusEtc',
    value: 'ETC',
    color: colors.graniteGray,
  },
];

/**
 * 관계 옵션 목록
 * 비상연락처 관계 선택을 위한 옵션 목록입니다.
 */
export const relationOption = [
  {text: 'me', value: 0},
  {text: 'spouse', value: 1},
  {text: 'daughter', value: 2},
  {text: 'son', value: 3},
  {text: 'mother', value: 4},
  {text: 'father', value: 5},
  {text: 'grandMother', value: 6},
  {text: 'grandFather', value: 7},
  {text: 'cousin', value: 8},
];

/**
 * 기저질환 옵션 목록
 * 기저질환 보유 여부 선택을 위한 옵션 목록입니다.
 */
export const underlyingConditionsOptions = [
  {text: 'have', value: true},
  {text: 'none', value: false},
];

/**
 * 경력 공개 상태 옵션 목록
 * 경력 공개 상태 선택을 위한 옵션 목록입니다.
 */
export const careerDisclosureStatusOptions = [
  {text: 'isPublicTrue', value: true},
  {text: 'isPublicFalse2', value: false},
];
/**
 * 경력 공개 상태 옵션 목록 (버전 2)
 * 경력 공개 상태 선택을 위한 옵션 목록입니다. (다른 화면용)
 */
export const careerDisclosureStatusOptions2 = [
  {text: 'isPublicTrue', value: true},
  {text: 'isPublicFalse', value: false},
];

/**
 * 혈액형 옵션 목록
 * 혈액형 선택을 위한 옵션 목록입니다.
 */
export const bloodTypeOptions = [
  {text: 'A', value: 0},
  {text: 'B', value: 1},
  {text: 'AB', value: 2},
  {text: 'O', value: 3},
];

/**
 * 일일 흡연량 옵션 목록
 * 일일 흡연량 선택을 위한 옵션 목록입니다.
 */
export const dailySmokingOptions = [
  {text: 'noSmoking', value: 0},
  {text: 'halfOrLess', value: 1},
  {text: 'oneOrLess', value: 2},
  {text: 'twoOrMore', value: 3},
];

/**
 * 주간 음주 횟수 옵션 목록
 * 주간 음주 횟수 선택을 위한 옵션 목록입니다.
 */
export const weeklyDrinkingOptions = [
  {text: 'doNotConsume', value: 0},
  {text: 'oneToTwoTimesPerWeek', value: 1},
  {text: 'threeToFiveTimesPerWeek', value: 2},
  {text: 'daily', value: 3},
];

/**
 * 일회 음주량 옵션 목록
 * 일회 음주량 선택을 위한 옵션 목록입니다.
 */
export const oneTimeAlcoholDrinkOptions = [
  {text: 'doNotConsume', value: 0},
  {text: 'halfBottle', value: 1},
  {text: 'oneBottle', value: 2},
  {text: 'twoOrMoreBottles', value: 3},
];

/**
 * 검색 날짜 카테고리 옵션 목록
 * 검색 날짜 카테고리 선택을 위한 옵션 목록입니다.
 */
export const searchDateCategoryOptions = [
  {text: 'thisMonth', value: 'thisMonth'},
  {text: 'last3Months', value: 'last3Months'},
];

/**
 * 소속 회사 옵션 목록
 * 소속 회사 선택을 위한 옵션 목록입니다.
 */
export const affiliatedCompanyOptions = [
  {text: 'partnerCompany', value: 'partnerCompany'},
  {text: 'constructionCompany', value: 'contractor'},
];

/**
 * 성별 옵션 목록
 * 성별 선택을 위한 옵션 목록입니다.
 */
export const genderOptions = [
  {text: 'male', value: 'MAN'},
  {text: 'female', value: 'WOMAN'},
];

/**
 * 성별 옵션 목록 (버전 2)
 * 성별 선택을 위한 옵션 목록입니다. (다른 화면용)
 */
export const genderOptions2 = [
  {text: 'man', value: 'MAN'},
  {text: 'woman', value: 'WOMAN'},
];

/**
 * 국적 옵션 목록
 * 국적 선택을 위한 옵션 목록입니다.
 */
export const nationalityOptions = [
  {text: 'korea', value: 'KR'},
  {text: 'america', value: 'US'},
  {text: 'china', value: 'CN'},
  {text: 'uzbekistan', value: 'UZ'},
  {text: 'vietnam', value: 'VN'},
  {text: 'russia', value: 'RU'},
  {text: 'thailand', value: 'TH'},
];

/**
 * 근무 상태 옵션 목록
 * 근무 상태 선택을 위한 옵션 목록입니다.
 */
export const workStatusOptions = [
  {text: 'approvedSameDayAttendance', value: 'approvedSameDayAttendance'},
  {text: 'workAfter', value: 'workAfter'},
];

/**
 * 교육 방법 옵션 목록
 * 교육 방법 선택을 위한 옵션 목록입니다.
 */
export const educationalMethodOption = [
  {text: 'LECTURE', value: 'LECTURE'},
  {text: 'HANDS-ON', value: 'HANDS-ON'},
];

/**
 * 공지사항 카테고리 옵션 목록
 * 공지사항 카테고리 선택을 위한 옵션 목록입니다.
 */
export const announcementsCategoryOption = [
  {text: 'entire', value: 'entire'},
  {text: 'tongAnnouncement', value: 'TONG_PLACE_ANNOUNCEMENT'},
];

/**
 * 승인 상태 옵션 목록
 * 승인 상태 선택을 위한 옵션 목록입니다.
 */
export const allowStateOption = [
  {text: 'registrationPending', value: 'REQUESTED'},
  {text: 'registrationCompleted', value: 'ALLOWED'},
  {text: 'registrationCancelled', value: 'DISALLOWED'},
];

/**
 * 일반 공지 옵션 목록
 * 상태 생성 시 일반 공지 선택을 위한 옵션 목록입니다.
 */
export const isNormalAnnouncementOption = [
  {text: '현장통 공지', value: 'isNormalAnnouncement'},
];
/**
 * 건강 상태 옵션 목록
 * 상태 생성 시 건강 상태 선택을 위한 옵션 목록입니다.
 */
export const healthStatusOption = [
  {text: '긴급 점검', value: 'ApplyingHotfix'},
  {text: '정기 점검', value: 'InMaintenanceMode'},
  {text: '정상 운영중', value: 'OperatingNormally'},
];

export const dataOffsetOption = [
  {text: '연', value: 'year'},
  {text: '월', value: 'month'},
  {text: '주', value: 'week'},
  {text: '일', value: 'day'},
];

export const stateOption = [
  {text: 'completeApprove', value: 'ALLOWED'},
  {text: 'waitApproval', value: 'REQUESTED'},
  {text: 'permissionRevoked', value: 'DISALLOWED'},
];

export const paymentStateOption = [
  {text: 'outstanding', value: false},
  {text: 'successPayment', value: true},
];
